<div class="settings__block settings__block_flex">
  <h4 class="body-1 settings__title">{{ 'SETTINGS.INSTRUCTIONS' | translate }}</h4>
  <base-boolean-field
    [control]="instructionToggleControl"
    [type]="BooleanFieldType.toggle"
    class="mat-mdc-slide-toggle_blue"
  ></base-boolean-field>
</div>
<mat-divider></mat-divider>
